export { useAPIFetchTechDetails } from './fetch-technical-details.hook';
export * from './fetch-technical-details.hook.types';
